import { axios } from '@/utils/request'
const api = {
  source: '/finance/masterController',
  get:'/finance/statementRreceiver',
  template:'/finance/statement'
  // /finance/enterpriseStatement/queryAlreadyPay /finance/enterpriseStatement/refund 退款

}
export function getupdateSettleAmount (parameter) {
  return axios({
    url:  '/finance/masterController/updateAmount',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
export function getupdateExpectDate (parameter) {
  return axios({
    url: api.source + '/updateExpectDate',
    method: 'get',
    params: parameter
  })
}
export function getexportList (parameter) {
  return axios({
    url: '/finance/masterController/detailExport',
    method: 'get',
    params: parameter,
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}
// 获取需要支付金额
export function getQueryNeedPay (parameter) {
  return axios({
    url: api.source + '/needSettleAmount',
    method: 'get',
    params: parameter
  })
}
// 获取需要已支付金额
export function getAlreadyPay (parameter) {
  return axios({
    url: api.source + '/alreadySettleAmount',
    method: 'get',
    params: parameter
  })
}
// 提交 分单
export function getSeparateList (parameter) {
  return axios({
    url: api.source + '/separateStatement',
    method: 'GET',
    params: parameter,
  })}
// 结算
export function getEnterpriseSettleList (parameter) {
  return axios({
    url: api.source + '/settle',
    method: 'post',
    data: parameter,
    timeout: 600000,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// /finance/enterpriseStatement/refund 退款
export function getRefundList (parameter) {
  return axios({
    url: api.source + '/refund ',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
// 账单移除
export function removeList (parameter) {
  return axios({
    url: api.source + '/removeOrder',
    method: 'GET',
    params: parameter,
  })}
// 获取企业对账单接收人
export function getStatementRreceiver (parameter) {
  return axios({
    url: api.get + '/get',
    method: 'GET',
    params: parameter,
  })}
export function getTemplate (parameter) {
  return axios({
    url: api.template + '/template/get',
    method: 'GET',
    params: parameter,
  })}
export const sourceExport = api.source + '/export'